<app-back-link></app-back-link>

<ng-container *ngIf="!loading && request && uuid && !printing">
  <!-- <div class="row my-2">
    <div class="col">
      <it-back-button buttonStyle="link"></it-back-button>
    </div>
  </div> -->

  <div class="row align-items-center">
    <div class="col">
      <p class="title h4">{{'DOSSIER_NUMBER' | label }} {{ request.code }}</p>
    </div>
    <div class="col-6 text-end">
      <div class="d-flex justify-content-end flex-wrap gap-2">
        <h5>
        <ng-container *ngIf="request.substatus">
          <span
            
            [itBadge]="'warning'"
            [rounded]="'true'"
            class="text-nowrap"
          >
            {{ request.substatus }}
          </span>
        </ng-container>

        <!-- <span *ngIf="!hasConsentAttachment()" [itBadge]="'danger'" [rounded]="'true'" class="text-nowrap me-2">
          Consenso non raccolto
        </span>
        <span *ngIf="hasConsentAttachment()" [itBadge]="'success'" [rounded]="'true'" class="text-nowrap me-2">
          Consenso raccolto
        </span> -->

        <span [itBadge]="'primary'" [rounded]="'true'" class="text-nowrap">
          {{ request.status.name }}
        </span>
        </h5>
      </div>
    </div>
  </div>

  <div class="row mt-2 mb-2">
    <div class="col text-end" *ngIf="!showFormPage">
      <app-request-action
        [request]="request"
        [isConsentMissing]="!hasConsentAttachment()"
        [requestDates]="requestDates"
        (refreshRequest)="loadAllData(uuid)"
        *ngIf="!readonly"
      ></app-request-action>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>

  <div class="row mt-2 mb-2" *ngIf="selectedForm && showFormPage">
      <div class="col-2">
        <button
          itButton="outline-primary"
          size="xs"
          type="button"
          class="me-2"
          (click)="reset()"
        >
          <it-icon
            [name]="'arrow-left'"
            [color]="'primary'"
            class="me-2"
          ></it-icon>
          Torna alla pratica
        </button>
      </div>
      <div class="col text-end">

        <ng-container *ngIf="context.readonly">
           <button 
            itButton="success" 
            *ngIf="selectedForm.transitionFormId && selectedForm.formStatus?.code === 'BOZZA' && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result ==='KO') && !readonly"
            size="xs"
            type="button"
            class="me-2"
            (click)="completeForm()">
            Rendi Definitivo
          </button>
          <button 
            itButton="danger" 
            *ngIf="selectedForm.transitionFormId && selectedForm.formStatus?.code != 'ANNULLATO' && selectedForm.formStatus?.code != 'ANNULLATO' && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result ==='KO') && !readonly"
            size="xs"
            type="button"
            class="me-2"
            (click)="deleteForm()">
            Annulla modulo
          </button>

          <ng-container *ngIf="context.readonly">
            <button
              *ngIf="selectedForm.formStatus?.code !== 'FIRMATO'"
              (click)="goToPrintWindow()"
              itButton="primary"
              size="xs"
              class="me-2"
              type="button"
            >
              <span>Stampa modulo</span>
            </button>
            <button
              *ngIf="selectedForm.formStatus?.code === 'FIRMATO'"
              (click)="printAttachment(this.selectedForm)"
              itButton="primary"
              size="xs"
              class="me-2"
              type="button"
            >
              <span>Stampa modulo firmato</span>
            </button>
          </ng-container>
     
          <button
            *ngIf="selectedForm.formStatus?.code == 'COMPILATO' && !readonly && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result ==='KO')"
            (click)="uploadAttachment()"
            itButton="primary"
            size="xs"
            class="me-2"
            type="button"
          >
            <span>Upload/Firma</span>
          </button>
          <button
            *ngIf="selectedForm.formStatus?.code == 'FIRMATO'"
            (click)="downloadAttachment(this.selectedForm)"
            itButton="primary"
            size="xs"
            class="me-2"
            type="button"
          >
            <span>Download</span>
          </button>
        </ng-container>

        <button
          *ngIf="context.readonly && selectedForm.formStatus?.code !='ANNULLATO' && !readonly && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result ==='KO')"
          itButton="primary"
          size="xs"
          type="button"
          class="me-2"
          (click)="modifyForm()"
        >
          <span>Modifica modulo</span>
        </button>

        <button
          *ngIf="!context.readonly && !readonly"
          itButton="outline-danger"
          size="xs"
          type="button"
          class="me-2"
          [disabled]="isSaving || !formChanged"
          (click)="cancelForm()"
        >
          <span>Annulla modifiche</span>
        </button>

        <button
          itButton="success"
          *ngIf="!context.readonly && selectedForm.formStatus?.code != 'COMPILATO' && selectedForm.formStatus?.code != 'FIRMATO' && selectedForm.formStatus?.code != 'ANNULLATO' && !readonly && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result ==='KO')"
          size="xs"
          type="button"
          class="me-2"
          [disabled]="isSaving || !formChanged"
          (click)="save()"
        >
          <span
            *ngIf="isSaving"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          <span *ngIf="!isSaving">Salva come Bozza</span>
          <span *ngIf="isSaving">Salvataggio in corso...</span>
        </button>

       <button
          itButton="success"
          *ngIf="!context.readonly && !readonly && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result ==='KO')"
          size="xs"
          type="button"
          [disabled]="isSaving || !formChanged"
          (click)="save(false)"
        >
          <span
            *ngIf="isSaving"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          <span *ngIf="!isSaving">Salva come Definitivo</span>
          <span *ngIf="isSaving">Salvataggio in corso...</span>
        </button>
      </div>
  </div>

  <div class="row" *ngIf="!showFormPage">
    <div class="col">
      <it-card teaser="true" shadow="true">
        
        <div class="d-flex justify-content-between align-items-center mb-2" *ngIf="!readonly">
          <h5 class="fw-bold mb-0">Moduli disponibili:</h5>
          <button
            itButton="outline-primary"
            size="xs"
            type="button"
            data-bs-toggle="modal" data-bs-target="#newModuleModal"
          >
            <it-icon name="plus" color="primary" class="me-1"></it-icon> Aggiungi modulo
          </button>
        </div>

        <app-form-row
          (formSelected)="onFormSelected($event)"
          (printForm)="printForm($event)"
          (formStatusChanged)="loadAllData(uuid)"
          (uploadAttachment)="uploadAttachment($event)"
          (downloadAtachment)="downloadAttachment($event)"
          (modify)="modifyForm($event)"
          (delete)="deleteForm($event)"
          *ngFor="let form of forms"
          [request]="request"
          [form]="form"
          [readonly]="readonly"
          [enrollementData]="enrollementData"
        ></app-form-row>
      </it-card>
      <div class="container mt-2"></div>
    </div>

    <div class="col-lg-6">
      <it-card teaser="true" shadow="true">
        <it-tab-container
          auto="true"
          [cards]="'true'"
          (tabSelected)="tabSelected($event)"
        >
          <it-tab-item label="Pianificazione" active="true" *ngIf="request.setting.code!='ADI'">
            <app-discharge-info-action *ngIf="this.request && !readonly" [request]="request" [requestDates]="requestDates" (refreshRequest)="loadAllData(uuid)"></app-discharge-info-action>
             <app-discharge-info *ngIf="this.request" [request]="request" [dischargeInfo]="requestDates"></app-discharge-info>
          </it-tab-item>
          <it-tab-item label="Arruolamento" active="true" *ngIf="request.setting.code=='ADI'">
            <app-enrollement-action *ngIf="this.request && !readonly" [enrollementData]="enrollementData" [request]="request" [requestDates]="requestDates" (refreshRequest)="loadAllData(uuid)"></app-enrollement-action>
             <app-enrollement-info *ngIf="this.request" [request]="request" [enrollementData]="enrollementData" [dischargeInfo]="requestDates"></app-enrollement-info>
          </it-tab-item>
          <it-tab-item [label]="'Notifiche (' + getNoficationNumber() + ')'">
            
            <div *ngIf="notifications?.length === 0">Nessuna notifica disponibile.</div>
            <app-notification-card
              *ngFor="let nota of notifications" (notificationRead)="loadNotes()"
              [note]="nota"
            >
            </app-notification-card>
          </it-tab-item>
          <it-tab-item label="Allegati">
            <div class="row mb-3">
              <button *ngIf="!readonly"
                [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
                data-bs-toggle="modal" data-bs-target="#attachModal">
                Inserisci nuovo allegato
              </button>
            </div>
            <app-attach-card
              *ngFor="let att of attachments"
              [attachment]="att"
              [canDelete]="!att.transitionFormId && !readonly"
              (refresh)="reloadAttachments()">
            </app-attach-card>
          </it-tab-item>
          <it-tab-item id="note" label="Note">
            <div class="row mb-3">
              <button *ngIf="!readonly"
                [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
                data-bs-toggle="modal" data-bs-target="#noteModal">
                Inserisci Nuova Nota
              </button>
            </div>
            <div *ngIf="notes?.length === 0">Nessuna nota disponibile.</div>
            <app-note-card
              *ngFor="let nota of notes"
              [note]="nota"
            >
            </app-note-card>
          </it-tab-item>
          <it-tab-item label="Storico">
            <it-timeline
              [timelineElements]="timelineElements"
              [dateFormat]="defaultDateFormat"
            />
          </it-tab-item>
        </it-tab-container>
      </it-card>
    </div>
  </div>

<div class="row mt-2" *ngIf="selectedForm && showFormPage">
  <div class="col">
    
    <it-progress-bar *ngIf="loadingForm" color="primary" [value]="0" indeterminate="true"></it-progress-bar>

    <it-card teaser="true" shadow="true">
      <form-renderer
        id="form"
        *ngIf="showForm"
        #fr
        [formMetadata]="formMetaData"
        [ehrServerUrl]="ehrServerUrl"
        [credentials]="credentials"
        [context]="context"
        [formEnvironment]="formEnvirorment"
        [compositionId]="compositionId"
        (onValueChange)="valueChange($event)"
        (onFormRendered)="formRendered($event)"
        (onFormError)="formError($event)"
      >
      </form-renderer>
    </it-card>
  </div>
</div>


  <!-- <div class="row mt-2 mb-2">
    <ng-container *ngIf="selectedForm">
      <div class="col-2">
        <button
          itButton="outline-primary"
          size="xs"
          type="button"
          class="me-2"
          (click)="reset()"
        >
          <it-icon
            [name]="'arrow-left'"
            [color]="'primary'"
            class="me-2"
          ></it-icon>
          Torna alla pratica
        </button>
      </div>
      <div class="col text-end">
        <button
          itButton="success"
          *ngIf="!context.readonly"
          size="xs"
          type="button"
          [disabled]="isSaving || !formChanged"
          (click)="save()"
        >
          <span
            *ngIf="isSaving"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          <span *ngIf="!isSaving">Salva modifiche</span>
          <span *ngIf="isSaving">Salvataggio in corso...</span>
        </button>
      </div>
    </ng-container>
  </div> -->
</ng-container>

<it-modal
  #noteModal="itModal"
  alignment="right"
  scrollable="true"
  id="noteModal"
  size="xl"
>
  <ng-container modalTitle>Nuova Nota</ng-container>
  <div class="row">
    <div class="col">
      <app-new-note-modal [transitionId]="request?.id!" (newNote)="addedNewNote()" (cancelled)="cancelledNewNote()"></app-new-note-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #newModuleModal="itModal"
  scrollable="true"
  id="newModuleModal"
  >
  <ng-container modalTitle>Aggiungi modulo</ng-container>
  <div class="row">
    <div class="col">
      <app-add-module [forms]="this.formsToAdd!" (newModule)="addedNewModule($event)" (cancelled)="cancelledNewModule()"></app-add-module>
    </div>
  </div>
</it-modal>

<it-modal
  #attachModal="itModal"
  alignment="right"
  scrollable="true"
  id="attachModal"
  size="xl"
>
  <ng-container modalTitle>Aggiungi allegato</ng-container>
  <div class="row">
    <div class="col">
      <app-new-attach-modal [transitionId]="request?.uuid!" (newAttach)="addedNewAttach()" (cancelled)="cancelledNewAttach()"></app-new-attach-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #attachSignedModal="itModal"
  alignment="right"
  scrollable="true"
  id="attachSignedModal"
  size="xl"
>
  <ng-container modalTitle>Allega modulo firmato</ng-container>
  <div class="row">
    <div class="col">
      <p>{{selectedForm?.name}}</p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-new-signed-attach-modal [transitionId]="request?.uuid!" [formType]="selectedForm?.code" [compositionId]="selectedForm?.compositionId" (newAttach)="addedNewSignedAttach()" (cancelled)="cancelledNewSignedAttach()"></app-new-signed-attach-modal>
    </div>
  </div>
</it-modal>

<it-back-to-top [small]="'true'" [shadow]="'true'" [dark]="'false'">
</it-back-to-top>

<div style="display: none" id="print-section">
  <form-renderer
    id="frPrint"
    *ngIf="showForm"
    #fr
    [formMetadata]="formMetaData"
    [ehrServerUrl]="ehrServerUrl"
    [credentials]="credentials"
    [context]="context"
    [formEnvironment]="formEnvirorment"
    [compositionId]="compositionId"       
  >
  </form-renderer>
</div>
